import React from "react";
import { Navigate } from "react-router-dom";
import {
  isLegacyTeamManagementEnabled,
  isPeopleModuleEnabled,
  LEGACY_TEAM_HOME_PATH,
  PEOPLE_HOME_PATH,
} from "../../config/featureFlags";

/**
 * Blocks a route when its module is disabled by REACT_APP_PEOPLE_MODULE_MODE.
 * @param {"people" | "legacy-team"} module
 */
export default function PeopleTeamModuleGuard({ module, children }) {
  if (module === "people" && !isPeopleModuleEnabled) {
    return <Navigate to={LEGACY_TEAM_HOME_PATH} replace />;
  }

  if (module === "legacy-team" && !isLegacyTeamManagementEnabled) {
    return <Navigate to={PEOPLE_HOME_PATH} replace />;
  }

  return children;
}
